module.exports = __webpack_public_path__ + "img/developer-dark.9c0b14fd.svg";